import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Card, CardContent, CardActions, Grid, Avatar } from '@mui/material';
import AdmissionForm from './AdmissionForm';
import { getStudentByParent } from '../api'; // Adjust import path as necessary
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const [showForm, setShowForm] = useState(false);
  const [children, setChildren] = useState([]);
  const navigate = useNavigate();
  const base ='http://34.67.251.33';

  useEffect(() => {
    const userId = localStorage.getItem("userID");
    if (userId) {
      getStudentByParent(userId)
        .then(data => {
          setChildren(data);
          console.log(data);
        })
        .catch(error => console.error("Error loading student info:", error));
    }
  }, []);

  const handleRegisterClick = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleViewDetails = (child) => {
    navigate(`/child-progress-admission/${child.id}`, { state: { child } });
    console.log("Navigate to details page for:", child.id);
  };

  return (
    <Box className="home-page-container" sx={{ p: 4 }}>
      <Paper sx={{ p: 4, mb: 4 }}>
        <Typography variant="h3" className="home-heading" gutterBottom>
          Welcome to the Admission Portal
        </Typography>

        {children.length > 0 && (
          <>
            <Typography variant="body1" gutterBottom>
              Admission in progress for the following children:
            </Typography>
            <Grid container spacing={2}>
              {children.map((child) => (
               <Grid item xs={12} sm={6} md={4} key={child.id}>
               <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                 <CardContent sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                   
                   <Typography variant="h5" sx={{ ml: 2 }}>{child.first_name} {child.last_name}</Typography>
                   <Avatar
                     alt={`${child.first_name} ${child.last_name}`}
                     src={`${base}${child.picture}`}
                     sx={{ width: 100, height: 100, ml: 2 }}
                   />
                 </CardContent>
                 <CardActions sx={{ justifyContent: 'center' }}>
                   <Button size="small" color="primary" onClick={() => handleViewDetails(child)}>
                     View Details
                   </Button>
                 </CardActions>
               </Card>
             </Grid>
             
              ))}
            </Grid>
          </>
        )}

        <Button variant="contained" color="primary" onClick={handleRegisterClick} sx={{ mt: 2 }}>
          Register Child
        </Button>
      </Paper>
      {showForm && <AdmissionForm onClose={handleCloseForm} />}
    </Box>
  );
};

export default HomePage;
